"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var transport_config_1 = require("./transport_config");
function SET_ARRIVAL(state, arr) {
    state.arrival = arr;
}
exports.SET_ARRIVAL = SET_ARRIVAL;
function SET_DEPARTURE(state, dep) {
    state.departure = dep;
}
exports.SET_DEPARTURE = SET_DEPARTURE;
function SET_DEP_CATEGORY(state, category) {
    state.departureConfig.category = category;
}
exports.SET_DEP_CATEGORY = SET_DEP_CATEGORY;
function SET_ARR_CATEGORY(state, category) {
    state.arrivalConfig.category = category;
}
exports.SET_ARR_CATEGORY = SET_ARR_CATEGORY;
function SET_CODE(state, code) {
    state.code = code;
}
exports.SET_CODE = SET_CODE;
function SET_TRANSPORTATION(state, transportations) {
    state.transportations = transportations;
    SET_TOTAL_PRICE(state, transportations);
}
exports.SET_TRANSPORTATION = SET_TRANSPORTATION;
function SET_CHECKIN_URL(state, url) {
    state.checkinUrl = url;
}
exports.SET_CHECKIN_URL = SET_CHECKIN_URL;
function SET_CHECKIN_TIME(state, checkinTime) {
    if (!checkinTime) {
        return;
    }
    if (checkinTime && !checkinTime.Start && !checkinTime.End) {
        state.checkinTime.Start = checkinTime.start;
        state.checkinTime.End = checkinTime.end;
    }
    else {
        state.checkinTime = checkinTime;
    }
}
exports.SET_CHECKIN_TIME = SET_CHECKIN_TIME;
function SET_TOTAL_PRICE(state, transportations) {
    var totalPrice = 0;
    for (var _i = 0, transportations_1 = transportations; _i < transportations_1.length; _i++) {
        var transportation = transportations_1[_i];
        if (transportation &&
            transportation.tariffType === state.selectedTariffType &&
            transportation.pricings !== undefined) {
            for (var _a = 0, _b = transportation.pricings.Pricing; _a < _b.length; _a++) {
                var pricing = _b[_a];
                totalPrice += parseFloat(pricing.amount);
            }
        }
    }
    state.totalPrice = totalPrice;
}
exports.SET_TOTAL_PRICE = SET_TOTAL_PRICE;
function SET_CLASS(state, selectedClass) {
    state.selectedClass = selectedClass;
}
exports.SET_CLASS = SET_CLASS;
function SET_TARIFF_TYPE(state, tariffType) {
    state.selectedTariffType = tariffType;
}
exports.SET_TARIFF_TYPE = SET_TARIFF_TYPE;
function RESET_STATE(state) {
    state.code = undefined;
    state.arrival = true;
    state.arrivalConfig = new transport_config_1.TransportConfig();
    state.departure = true;
    state.departureConfig = new transport_config_1.TransportConfig();
    state.totalPrice = 0;
    state.transportations = [];
    state.selectedClass = '2';
    state.selectedTariffType = 'spar';
}
exports.RESET_STATE = RESET_STATE;
// export everything compliant to the vuex specification for getters
exports.default = {
    SET_DEPARTURE: SET_DEPARTURE,
    SET_ARRIVAL: SET_ARRIVAL,
    SET_DEP_CATEGORY: SET_DEP_CATEGORY,
    SET_ARR_CATEGORY: SET_ARR_CATEGORY,
    SET_TRANSPORTATION: SET_TRANSPORTATION,
    SET_CHECKIN_URL: SET_CHECKIN_URL,
    SET_CHECKIN_TIME: SET_CHECKIN_TIME,
    SET_TOTAL_PRICE: SET_TOTAL_PRICE,
    SET_CLASS: SET_CLASS,
    SET_TARIFF_TYPE: SET_TARIFF_TYPE,
    SET_CODE: SET_CODE,
    RESET_STATE: RESET_STATE,
};
//# sourceMappingURL=mutations.js.map